/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'avator': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<defs/><g id="默认头像"><rect pid="0" class="cls-1" width="24" height="24" rx="12" ry="12"/><path pid="1" class="cls-2" d="M12 15.3c-2.8 0-8.4 1.41-8.4 4.2v1.06a12 12 0 0 0 16.8 0V19.5c0-2.79-5.6-4.2-8.4-4.2z"/><circle pid="2" class="cls-2" cx="12" cy="9" r="4.2"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/avator.js